module.exports = __webpack_public_path__ + "static/media/adf.20469190.svg";